/**
 * @file query strings取得用utility関数群
 */

import queryString from 'query-string'

function getQueryStrings(router) {
  const { location } = router

  return queryString.parse(location.search)
}

export { getQueryStrings }
